/* Learning Bugs homepage */
(function () {
  var root = document.getElementById('lbh');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s) { return root.querySelector(s); }
  function $$(s) { return [].slice.call(root.querySelectorAll(s)); }
  /* 29.09.26 (mobile): no scroll fade or fade-in on phones and touch screens (it made scrolling judder and faded text at the
     top and bottom of the screen), nor with reduced motion. There everything simply shows. Desktop keeps the effect. */
  var touchy = window.matchMedia('(hover: none), (pointer: coarse), (max-width: 767px)').matches;
  if (!reduce && !touchy && 'IntersectionObserver' in window) root.classList.add('js');

  /* ---- reveal on scroll ---- */
  var io = null;
  if (root.classList.contains('js')) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
  }
  /* fade every piece of the homepage (headings, text, each card, photo and button) as it scrolls, not whole blocks (26.09.26) */
  var fxSel = 'h2, h3, h4, p, blockquote, .lead, .card, .gtile, .note, .mk, .book, .btn, .tlink, figure, img, li, .budget a, .joinbox, .rsum, .hs-card';
  function fxTagAll(scope) {
    [].slice.call(scope.querySelectorAll('section:not(.hero) [data-reveal]')).forEach(function (el) {
      if (!el.matches(fxSel)) { el.removeAttribute('data-reveal'); el.classList.add('in'); }
    });
    [].slice.call(scope.querySelectorAll('section:not(.hero)')).forEach(function (sec) {
      [].slice.call(sec.querySelectorAll(fxSel)).forEach(function (el) {
        if (el.closest('.hero, template, script, [data-fx-skip]')) return;
        if (el.parentElement && el.parentElement.closest('[data-reveal]')) return;
        var cs = getComputedStyle(el);
        if (cs.position === 'fixed' || cs.position === 'absolute' && !el.matches('img')) return;
        el.setAttribute('data-reveal', '');
      });
    });
  }
  /* scroll fade (26.09.26): each part fades and rises in at the bottom of the screen and fades out again at the top.
     Only the content moves; coloured backgrounds stay still. Works in every browser. */
  if (io) {
    var hf = root.querySelector('.hero .hero-frame'); if (hf) hf.setAttribute('data-fx-top', '');
    var fxEls = [], fxTick = false, fxHead = document.querySelector('.section-header');
    function fxCollect() { fxTagAll(root); fxEls = [].slice.call(root.querySelectorAll('[data-reveal], [data-fx-top]')); }
    if ('MutationObserver' in window) {
      var fxMo = new MutationObserver(function () { fxCollect(); fxQueue(); });
      [].slice.call(root.querySelectorAll('#s-cards, #p-best, #p-new')).forEach(function (n) { fxMo.observe(n, { childList: true, subtree: true }); });
    }
    function fxRun() {
      fxTick = false;
      var vh = window.innerHeight, zone = Math.max(90, vh * 0.2), top = 0;
      if (fxHead) { var hb = fxHead.getBoundingClientRect().bottom; if (hb > 0 && hb < vh * 0.4) top = hb; }
      for (var i = 0; i < fxEls.length; i++) {
        var el = fxEls[i], r = el.getBoundingClientRect();
        if (r.height === 0 && r.width === 0) continue;
        var enter = el.hasAttribute('data-fx-top') ? 1 : Math.min(1, Math.max(0, (vh - r.top) / zone));
        var leave = Math.min(1, Math.max(0, (r.bottom - top) / zone));
        var o = Math.min(enter, leave);
        el.style.setProperty('--fx-o', (0.04 + 0.96 * o).toFixed(3));
        el.style.setProperty('--fx-y', ((1 - enter) * 28 - (1 - leave) * 14).toFixed(1) + 'px');
      }
    }
    function fxQueue() { if (!fxTick) { fxTick = true; requestAnimationFrame(fxRun); } }
    fxCollect(); root.classList.add('lbfx'); fxRun();
    window.addEventListener('scroll', fxQueue, { passive: true });
    window.addEventListener('resize', function () { fxCollect(); fxQueue(); });
    window.addEventListener('load', function () { fxCollect(); fxQueue(); });
  }
  function watch(scope) {
    var seen = new Map();
    [].slice.call(scope.querySelectorAll('[data-reveal]')).forEach(function (el) {
      if (!io) { el.classList.add('in'); return; }
      var p = el.parentNode, n = seen.get(p) || 0;
      el.style.transitionDelay = Math.min(n * 0.06, 0.18) + 's'; seen.set(p, n + 1); io.observe(el);
    });
  }
  watch(root);
  function showNow(scope) { [].slice.call(scope.querySelectorAll('[data-reveal]')).forEach(function (el) { el.classList.add('in'); }); }

  /* ---- shop by age ---- */
  var DATA = [];
  try { DATA = JSON.parse(document.getElementById('lb-stage-data').textContent); } catch (e) {}
  var btns = $$('.books .stage'), cards = $('#s-cards'), chap = $('#s-chap'), peek = $('#s-peek');
  var prev = $('#s-prev'), next = $('#s-next'), hint = $('#s-hint');
  var current = +(root.getAttribute('data-start') || 2), cache = {}, EXTRA = 5;
  function place(i) {
    btns.forEach(function (b, j) { b.style.order = j * 2; b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    if (chap) chap.style.order = i * 2 + 1;
  }
  function setPeek(i) {
    var tpl = document.getElementById('lb-stage-' + i); if (!peek || !tpl) return;
    var box = document.createElement('div'); box.innerHTML = tpl.innerHTML;
    peek.innerHTML = [].slice.call(box.querySelectorAll('.card .pic')).slice(0, 2).map(function (a) {
      var im = a.querySelector('img'); if (!im) return '';
      return '<a href="' + a.getAttribute('href') + '" tabindex="-1"><img src="' + im.getAttribute('src') + '" alt="" loading="lazy" decoding="async"></a>';
    }).join('');
  }
  function arrows() {
    if (!cards || !prev || !next) return;
    var pic = cards.querySelector('.pic');
    if (pic) cards.parentNode.style.setProperty('--picH', pic.offsetHeight + 'px');
    prev.hidden = cards.scrollLeft < 8;
    next.hidden = cards.scrollLeft + cards.clientWidth >= cards.scrollWidth - 8;
  }
  function step(dir) {
    var c = cards.querySelector('.card'); if (!c) return;
    cards.scrollBy({ left: dir * (c.offsetWidth + 24), behavior: reduce ? 'auto' : 'smooth' });
  }
  function seeAll(d) {
    var a = document.createElement('a');
    a.className = 'card seeall'; a.href = '/collections/' + d.more;
    a.innerHTML = '<i aria-hidden="true">&rarr;</i><span>See all toys for ' + d.n + ' ' + d.u + '</span><small>' + d.label + '</small>';
    return a;
  }
  function addMore(i, html) {
    if (i !== current) return;
    var box = document.createElement('div'); box.innerHTML = html;
    var have = {}; [].slice.call(cards.querySelectorAll('.card[data-handle]')).forEach(function (c) { have[c.getAttribute('data-handle')] = 1; });
    var end = cards.querySelector('.seeall'), n = 0;
    [].slice.call(box.querySelectorAll('.card[data-handle]')).forEach(function (c) {
      if (n >= EXTRA || have[c.getAttribute('data-handle')]) return;
      c.classList.add('more', 'in'); cards.insertBefore(c, end); n++;
    });
    arrows();
  }
  function more(i) {
    var d = DATA[i]; if (!d || !d.more) return;
    cards.appendChild(seeAll(d));
    if (cache[i]) { addMore(i, cache[i]); return; }
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'collections/' + d.more + '?section_id=lb-stage-more')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { cache[i] = t; addMore(i, t); })
      .catch(function () {});
  }
  function show(i, kb) {
    var d = DATA[i], tpl = document.getElementById('lb-stage-' + i);
    if (!d || !tpl || i === current) return;
    current = i;
    if (hint) hint.classList.add('done');
    if (chap) chap.classList.add('swap');
    cards.classList.add('swap');
    setTimeout(function () {
      place(i);
      $('#s-tag').textContent = d.label + ' · ' + d.n + ' ' + d.u;
      $('#s-title').textContent = d.title;
      $('#s-text').textContent = d.line;
      var L = $('#s-link'); L.firstChild.textContent = d.link + ' '; L.setAttribute('href', d.href);
      setPeek(i);
      if (chap) { chap.classList.remove('swap', 'pop'); void chap.offsetWidth; chap.classList.add('pop'); }
      if (kb) L.focus({ preventScroll: true });
      cards.innerHTML = tpl.innerHTML;
      cards.scrollLeft = 0;
      showNow(cards);
      more(i);
      cards.classList.remove('swap');
      arrows();
    }, reduce ? 0 : 200);
  }
  /* phone: swipe carousel - the age in the middle is chosen, the others fade */
  var track = $('#s-track'), mq = window.matchMedia('(max-width: 640px)'), fadeTick = false, settle = null, jumping = false, nudging = false;
  var dots = $$('#s-dots i');
  function dot(i) { dots.forEach(function (d, j) { d.classList.toggle('on', j === i); }); }
  function centerOf(b) { return b.offsetLeft + b.offsetWidth / 2; }
  function fade() {
    fadeTick = false;
    if (!track || !mq.matches) return;
    var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = 1e9;
    btns.forEach(function (b, j) {
      var d = Math.abs(centerOf(b) - mid) / (b.offsetWidth + 12);
      if (d < bestD) { bestD = d; best = j; }
      var k = Math.min(d, 2);
      b.style.setProperty('--sc', (1 - k * 0.13).toFixed(3));
      b.style.setProperty('--op', (1 - k * 0.38).toFixed(3));
    });
    dot(best);
    return best;
  }
  function toCenter(i, smooth) {
    if (!track || !btns[i]) return;
    track.scrollTo({ left: centerOf(btns[i]) - track.clientWidth / 2, behavior: smooth && !reduce ? 'smooth' : 'auto' });
  }
  if (track) {
    track.addEventListener('scroll', function () {
      if (!mq.matches) return;
      if (!fadeTick) { fadeTick = true; requestAnimationFrame(fade); }
      clearTimeout(settle);
      settle = setTimeout(function () { var i = fade(); jumping = false; if (!nudging && i != null && i !== current) show(i); }, 140);
    }, { passive: true });
    addEventListener('resize', function () { if (mq.matches) { toCenter(current); fade(); } else btns.forEach(function (b) { b.style.removeProperty('--sc'); b.style.removeProperty('--op'); }); });
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function (e) { if (mq.matches && track) { toCenter(i, true); } show(i, e.detail === 0); }); });
  place(current); setPeek(current);
  if (mq.matches) requestAnimationFrame(function () { toCenter(current); fade(); });
  /* first time the ages come into view on a phone, the row gives a little nudge so people know it swipes */
  if (track && !reduce && 'IntersectionObserver' in window) {
    var nio = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting || !mq.matches) return;
      nio.disconnect();
      setTimeout(function () {
        nudging = true;
        var home = track.scrollLeft;
        track.scrollTo({ left: home + 64, behavior: 'smooth' });
        setTimeout(function () { track.scrollTo({ left: home, behavior: 'smooth' }); setTimeout(function () { nudging = false; }, 700); }, 650);
      }, 500);
    }, { threshold: 0.7 });
    nio.observe(track);
  }
  if (cards) {
    cards.addEventListener('scroll', function () { arrows(); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    more(current);
    requestAnimationFrame(arrows);
    addEventListener('resize', arrows);
    addEventListener('load', arrows);
  }
  /* ---- best sellers / new in ---- */
  var tb = $('#tab-best'), tn = $('#tab-new'), pb = $('#p-best'), pn = $('#p-new'), lk = $('#tabLink');
  function sel(isNew) {
    var from = isNew ? pb : pn, to = isNew ? pn : pb;
    if (!to.hidden) return;
    tb.setAttribute('aria-selected', !isNew); tn.setAttribute('aria-selected', isNew);
    from.classList.add('tabout');
    setTimeout(function () {
      from.classList.remove('tabout'); from.hidden = true; to.hidden = false;
      showNow(to);
      to.classList.remove('tabin'); void to.offsetWidth; to.classList.add('tabin');
      lk.firstChild.textContent = isNew ? 'Shop All New In ' : 'Shop All Best Sellers ';
      lk.setAttribute('href', isNew ? '/collections/new-arrivals' : '/collections/best-sellers');
    }, reduce ? 0 : 220);
  }
  if (tb && tn) { tb.addEventListener('click', function () { sel(false); }); tn.addEventListener('click', function () { sel(true); }); }

  /* ---- photo hotspots ---- */
  $$('.hs').forEach(function (h) {
    var b = h.querySelector('.hs-dot');
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      var o = !h.classList.contains('open');
      $$('.hs.open').forEach(function (x) { x.classList.remove('open'); });
      h.classList.toggle('open', o); b.setAttribute('aria-expanded', o);
    });
  });
  document.addEventListener('click', function () { $$('.hs.open').forEach(function (x) { x.classList.remove('open'); x.querySelector('.hs-dot').setAttribute('aria-expanded', 'false'); }); });

  /* ---- pause the moving strips while they are off screen ---- */
  if ('IntersectionObserver' in window) {
    var mo = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('off', !e.isIntersecting); }); });
    $$('.brands, .community').forEach(function (el) { el.classList.add('off'); mo.observe(el); });
  }

  /* ---- story scroll: loads its own small stylesheet only in browsers that support it ---- */
  (function () {
    if (reduce || !window.CSS || !CSS.supports || !CSS.supports('animation-timeline: view()')) return;
    var me = document.querySelector('script[src*="lb-home.js"]'); if (!me) return;
    var map = [['.hero', 'Welcome'], ['#stages', 'Who it’s for'], ['#best', 'Best loved'], ['#gifts', 'The gift edit'], ['.notes', 'What parents say'], ['.rooms2', 'For their room'], ['.promise', 'Our story'], ['.club', 'Rewards'], ['.community', 'Follow along']];
    var link = document.createElement('link'); link.rel = 'stylesheet'; link.href = me.src.replace('lb-home.js', 'lb-story.css');
    link.onload = function () {
      var chapters = [];
      map.forEach(function (m) { var el = $(m[0]); if (!el) return; if (m[0] !== '.hero') el.classList.add('chapter'); chapters.push([el, m[1]]); });
      $$('.qband, .promise, .brands').forEach(function (el) { el.classList.add('chapter'); });
      var nav = document.createElement('nav'); nav.className = 'story-thread'; nav.setAttribute('aria-label', 'Page sections');
      chapters.forEach(function (c) {
        var a = document.createElement('a'); a.href = '#'; a.setAttribute('aria-label', c[1]); a.innerHTML = '<span>' + c[1] + '</span>';
        a.addEventListener('click', function (e) { e.preventDefault(); c[0].scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        nav.appendChild(a); c.push(a);
      });
      root.appendChild(nav);
      var bar = document.createElement('div'); bar.className = 'story-bar'; bar.setAttribute('aria-hidden', 'true'); root.appendChild(bar);
      var cur = null;
      var so = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var c = chapters.filter(function (x) { return x[0] === e.target; })[0];
          if (!c || c === cur) return;
          if (cur) cur[2].classList.remove('on');
          c[2].classList.add('on'); cur = c;
        });
      }, { rootMargin: '-45% 0px -54% 0px' });
      chapters.forEach(function (c) { so.observe(c[0]); });
      root.classList.add('story');
    };
    document.head.appendChild(link);
  })();

  /* ---- New in: newest products, one colour of each (26.09.26) ---- */
  (function () {
    var box = root.querySelector('#p-new'); if (!box || box.hasAttribute('data-manual') || !window.fetch || !window.DOMParser) return;
    var n = parseInt(box.getAttribute('data-n'), 10) || 10;
    fetch('/collections/all?sort_by=created-descending&view=lbnew', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = [].slice.call(doc.querySelectorAll('#lbnew > .card')).slice(0, n);
        if (cards.length < 4) return;
        box.innerHTML = '';
        cards.forEach(function (c) { box.appendChild(document.importNode(c, true)); });
        box.dispatchEvent(new CustomEvent('lb:rail'));
      }).catch(function () {});
  })();

  /* ---- arrows for rows that scroll sideways on desktop (New in, Meet the brands) ---- */
  function lbRail(el) {
    if (!el || el.dataset.rail) return; el.dataset.rail = '1';
    var wrap = document.createElement('div'); wrap.className = 'lb-rail';
    el.parentNode.insertBefore(wrap, el); wrap.appendChild(el);
    var svg = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
    var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'lb-rail__btn lb-rail__prev'; prev.setAttribute('aria-label', 'Scroll back'); prev.innerHTML = svg;
    var next = document.createElement('button'); next.type = 'button'; next.className = 'lb-rail__btn lb-rail__next'; next.setAttribute('aria-label', 'Scroll on'); next.innerHTML = svg;
    wrap.appendChild(prev); wrap.appendChild(next);
    function step(d) { var first = el.firstElementChild; var w = first ? first.getBoundingClientRect().width + 20 : el.clientWidth / 2; el.scrollBy({ left: d * Math.max(w, el.clientWidth - w), behavior: 'smooth' }); }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    function upd() { var max = el.scrollWidth - el.clientWidth - 4; prev.hidden = el.scrollLeft <= 4; next.hidden = el.scrollLeft >= max; wrap.classList.toggle('is-static', max <= 0); }
    el.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); el.addEventListener('lb:rail', function () { el.scrollLeft = 0; setTimeout(upd, 50); });
    setTimeout(upd, 50);
  }
  lbRail(root.querySelector('#p-best'));
  lbRail(root.querySelector('#p-new'));
  lbRail(root.querySelector('.makers .mk-row'));

  /* ---- phone "find the right toy" pill ---- */
  var pill = $('#pill'), hero = $('.hero'), stages = $('#stages'), tick = false;
  function onScroll() {
    tick = false;
    if (pill && hero && stages) {
      var hb = hero.getBoundingClientRect().bottom, sr = stages.getBoundingClientRect();
      var inStages = sr.top < innerHeight * 0.6 && sr.bottom > innerHeight * 0.3;
      pill.classList.toggle('show', hb < 0 && !inStages);
    }
  }
  addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  /* ---- quick Add to Cart: uses the site-wide cart drawer (sections/cart-drawer.liquid), 29.09.26 ----
     Same steps as assets/lb-quick-add.js: add, update the header count, refresh the drawer; then open it. */
  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || cartRoot + 'cart/add.js';
  var cartUrl = (window.theme && theme.routes && theme.routes.cart) || cartRoot + 'cart';
  function updateCount() {
    fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__count').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? cart.item_count : '';
        });
      })
      .catch(function () {});
  }
  function add(variant, btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var label = btn.textContent; btn.textContent = 'Adding…'; btn.setAttribute('aria-busy', 'true');
    function reset() { btn.textContent = label; btn.removeAttribute('aria-busy'); btn.classList.remove('err'); }
    fetch(addUrl, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +variant, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        reset();
        updateCount();
        if (!document.querySelector('cart-drawer')) { window.location.href = cartUrl; return; }
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: btn } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function (err) {
        btn.textContent = (err && typeof err.description === 'string' && err.description) || 'Unavailable';
        btn.classList.add('err');
        setTimeout(reset, 2500);
      });
  }
  root.addEventListener('click', function (e) {
    var q = e.target.closest('.qa'); if (!q) return;
    var card = q.closest('.card'); if (!card) return;
    if (q.classList.contains('soldout')) { e.preventDefault(); return; }
    var v = card.getAttribute('data-variant');
    if (!v || q.tagName !== 'BUTTON') return; /* products with options: the photo link goes to the product page */
    e.preventDefault(); e.stopPropagation();
    add(v, q);
  }, true);
})();
